export const buildResolvedAction = _ref => {
  let status = _ref.status,
    commonProps = _ref.commonProps,
    statuses = _ref.statuses,
    actionHandlers = _ref.actionHandlers,
    statusesCustomComponents = _ref.statusesCustomComponents;
  const actionHandler = status ? actionHandlers == null ? void 0 : actionHandlers[status] : undefined;
  const statusFactory = status ? statuses[status] : undefined;
  const base = commonProps && statusFactory ? statusFactory({
    ...commonProps,
    actionHandler
  }) : undefined;
  const autoInvoke = (commonProps == null ? void 0 : commonProps.autoInvoke) || (base && 'autoInvoke' in base ? base.autoInvoke : undefined);
  const StatusComponent = (status ? statusesCustomComponents == null ? void 0 : statusesCustomComponents[status] : undefined) ?? (base == null ? void 0 : base.StatusComponent);
  return {
    status,
    action: base == null ? void 0 : base.action,
    autoInvoke,
    StatusComponent: StatusComponent
  };
};
//# sourceMappingURL=buildResolvedAction.js.map